/* eslint-disable */

export const CommerceRequirementState = {
  Required: 'required',
  Satisfied: 'satisfied',
  Blocked: 'blocked',
  Deferred: 'deferred'
} as const;
export type CommerceRequirementState = typeof CommerceRequirementState[keyof typeof CommerceRequirementState];
